// extracted by mini-css-extract-plugin
export default {"widgets":"WidgetGroupContent_widgets__z33zx","gridContainer":"WidgetGroupContent_gridContainer__1cJOl","gridDropOverlay":"WidgetGroupContent_gridDropOverlay__7w0Ry"};